export default __webpack_public_path__ + "static/english-express-llm-chatbot-98813f7a757f83eb6a7c871431789495.png";